import Vue from 'vue'
import Vuex, { StoreOptions, ActionContext } from 'vuex';

const module = {
  namespaced: true, // 지정을 해줘야 RootState와 따로 동작한다. 없으면, RootState 변경시 같이 변경
  state: {
    empName: null,
    empEmail: null,
    empNumber: null,
    userLevel: null,
    userIdcAuth: null,
    // 안전작업관리자 여부 (userLevel 과 별개 축 — 설정 명단 기반, BE 가 내려줌)
    safetyWorkManager: false,
    isLogin: false
  },
  mutations: {
    LOGIN(state, {empName, empEmail, empNumber, userLevel, userIdcAuth, safetyWorkManager}) {
      state.empName = empName;
      state.empEmail= empEmail;
      state.empNumber = empNumber;
      state.userLevel = userLevel;
      state.userIdcAuth = userIdcAuth;
      state.safetyWorkManager = !!safetyWorkManager;
      state.isLogin = true;
    },
    LOGOUT(state) {
      state.empName = null;
      state.empEmail = null;
      state.empNumber = null;
      state.userLevel = null;
      state.userIdcAuth = null;
      state.safetyWorkManager = false;
      state.isLogin = false;
    }
  },
  actions: {
    LOGIN({commit}){
      return Vue.prototype.$http
        .post('/api/private/user/login', null)
        .then((result) => {
          commit("LOGIN", result.data);
          return true;
        }).catch((e) =>{
          commit("LOGOUT");
          return false;
        })
    },
    LOGOUT({ commit }) {
      commit("LOGOUT")
    },
  },
  getters: {
    location: function(state){
      state.location = JSON.parse(localStorage.getItem('location') || null);
      return state.location;
    },

    getDefaultIdcCode: function(state){
      return state.userIdcAuth.filter((data)=>{
        return data.isDefault == 1;
      })[0].locationCode;
    }
  }
}
export default module;
